module.exports = __webpack_public_path__ + "img/em3.96b71ab0.jpg";